import { render, staticRenderFns } from "./SanitarioEvolui.vue?vue&type=template&id=6adf621a&scoped=true"
import script from "./SanitarioEvolui.vue?vue&type=script&lang=js"
export * from "./SanitarioEvolui.vue?vue&type=script&lang=js"
import style0 from "./SanitarioEvolui.vue?vue&type=style&index=0&id=6adf621a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf621a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VCol,VRow})
